"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerConfig = getCustomerConfig;
exports.saveCustomerConfig = saveCustomerConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function getCustomerConfig(params) {
  return (0, _request.default)({
    url: '/portal/system/customer/config/query',
    method: 'get',
    params: params
  });
}
function saveCustomerConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/customer/config/save',
    method: 'post',
    data: data
  });
}